import { __decorate, __metadata } from "tslib";
// deep imports to fix circular deps in jest
import { AppRequest } from '../app-request/app-request.decorator';
import { Expose, Model, ModelId } from '../model';
import { AppRequestMethod } from '../request';
let PingServerRequest = /*#__PURE__*/(() => {
  let PingServerRequest = class PingServerRequest extends Model {};
  PingServerRequest = __decorate([AppRequest('core', 'ping', {
    httpMethod: AppRequestMethod.POST
  }), ModelId("PingServerRequest") // auto-generated by generate-model-ids
  ], PingServerRequest);
  return PingServerRequest;
})();
export { PingServerRequest };
let ServerStatusResponse = /*#__PURE__*/(() => {
  let ServerStatusResponse = class ServerStatusResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", String)], ServerStatusResponse.prototype, "status", void 0);
  ServerStatusResponse = __decorate([ModelId("ServerStatusResponse") // auto-generated by generate-model-ids
  ], ServerStatusResponse);
  return ServerStatusResponse;
})();
export { ServerStatusResponse };
let ServerStatusRequest = /*#__PURE__*/(() => {
  let ServerStatusRequest = class ServerStatusRequest extends Model {
    static {
      this.Response = ServerStatusResponse;
    }
  };
  ServerStatusRequest = __decorate([AppRequest('core', 'status', {
    httpMethod: AppRequestMethod.GET
  }), ModelId("ServerStatusRequest") // auto-generated by generate-model-ids
  ], ServerStatusRequest);
  return ServerStatusRequest;
})();
export { ServerStatusRequest };